/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIAlert } from './APIAlert';
import {
    APIAlertFromJSON,
    APIAlertFromJSONTyped,
    APIAlertToJSON,
    APIAlertToJSONTyped,
} from './APIAlert';

/**
 * Response model for alerts endpoint.
 * @export
 * @interface AlertsResponse
 */
export interface AlertsResponse {
    /**
     * 
     * @type {Array<APIAlert>}
     * @memberof AlertsResponse
     */
    alerts: Array<APIAlert>;
}

/**
 * Check if a given object implements the AlertsResponse interface.
 */
export function instanceOfAlertsResponse(value: object): value is AlertsResponse {
    if (!('alerts' in value) || value['alerts'] === undefined) return false;
    return true;
}

export function AlertsResponseFromJSON(json: any): AlertsResponse {
    return AlertsResponseFromJSONTyped(json, false);
}

export function AlertsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'alerts': ((json['alerts'] as Array<any>).map(APIAlertFromJSON)),
    };
}

export function AlertsResponseToJSON(json: any): AlertsResponse {
    return AlertsResponseToJSONTyped(json, false);
}

export function AlertsResponseToJSONTyped(value?: AlertsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alerts': ((value['alerts'] as Array<any>).map(APIAlertToJSON)),
    };
}

